export default __webpack_public_path__ + "static/media/jaguar.81054465.svg";